import imageUrlBuilder from '@sanity/image-url'
import { useSanity } from '#imports'

export default defineNuxtPlugin(() => {
	const builder = imageUrlBuilder(useSanity().config)

	function urlFor(source, width) {
		let image = builder.image(source).auto('format')
		if (width) {
			image = image.width(width)
		}
		return image.url()
	}

	return {
		provide: { urlFor }
	}
})
